import plus_icon from "./Plus.svg";
import menu_icon from "./Menu.svg";
import close_icon from "./Close.svg";
import edit_icon from "./Edit.svg";

export default {
  plus_icon: plus_icon,
  menu_icon: menu_icon,
  close_icon: close_icon,
  edit_icon: edit_icon,
};
